import type {MinaParaAsignar} from '@cnc/contracts';
import {tr} from '../i18n/idioma';
import {numero} from '../utilidades/formato';

// Casillas con las minas del exportador que tienen Big Bags para asignar.
// Ninguna marcada = todas las minas del exportador.
export function ElegirMinas({
  minas,
  elegidas,
  onCambiar,
  deshabilitado = false,
}: {
  minas: MinaParaAsignar[];
  elegidas: number[];
  onCambiar: (minas: number[]) => void;
  deshabilitado?: boolean;
}) {
  if (!minas.length) return null;
  const alternar = (id: number, marcar: boolean) =>
    onCambiar(marcar ? [...elegidas, id] : elegidas.filter(x => x !== id));
  return (
    <fieldset className="text-sm" disabled={deshabilitado}>
      <legend className="text-apagado">
        {tr('Asignar Big Bags de las minas:', 'Assign Big Bags from the mines:')}{' '}
        <span className="text-xs">
          {elegidas.length
            ? tr(`${elegidas.length} elegida(s)`, `${elegidas.length} chosen`)
            : tr('todas (ninguna marcada)', 'all (none checked)')}
        </span>
      </legend>
      <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1">
        {minas.map(m => (
          <label key={m.id} className="flex items-center gap-1.5">
            <input type="checkbox" checked={elegidas.includes(m.id)} onChange={e => alternar(m.id, e.target.checked)} />
            {m.nombre}
            <span className="text-xs text-apagado">
              ({tr(`${numero(m.disponibles)} disp.`, `${numero(m.disponibles)} avail.`)})
            </span>
          </label>
        ))}
        {elegidas.length > 0 && (
          <button type="button" className="text-xs text-verde hover:underline" onClick={() => onCambiar([])}>
            {tr('Todas las minas', 'All mines')}
          </button>
        )}
      </div>
    </fieldset>
  );
}
